import { extend, localize } from 'vee-validate';
import ja from '@/plugins/i18n/locales/ja/validation';
import { ValidatorNames } from 'types/validator';
import { ValidationRule } from 'vee-validate/dist/types/types';
import { email, min, required } from 'vee-validate/dist/rules';

// custom
import equal from '@/plugins/validation/validators/equal';
import optional_date from '@/plugins/validation/validators/optional_date';
import original_path from '@/plugins/validation/validators/original_path';
import required_checkbox from '@/plugins/validation/validators/required_checkbox';
import url from '@/plugins/validation/validators/url';

// Define custom validation rule
export const rules: { [key in ValidatorNames]: ValidationRule } = {
  // vee-validator's
  email,
  required,
  min,

  // custom
  equal,
  optional_date,
  original_path,
  required_checkbox: required_checkbox,
  url,
};

Object.keys(rules).forEach(ruleName => extend(ruleName, rules[ruleName]));

localize('ja', ja);
